import cn from "app/utils/classnames";
import SpellingBeeRound from "app/spelling-bee/SpellingBeeRound";
import BuzzInRound from "app/buzz-in/BuzzInRound";
import SpeedRound from "app/speed/SpeedRound";
import TedWordRound from "app/ted-word/TedWordRound";
import OneChanceRound from "app/one-chance/OneChanceRound";
import useGameData from "app/game-data/useGameData";
import { useGameActionDispatch, useGameState } from "app/game/useGame";
import { GameAction } from "app/game/gameState";
import { RoundType } from "app/game-data/useFetchGameData";
import Header from "app/ui/Header";
import { ROUND_TITLE_BY_ROUND_TYPE } from "app/data/game-settings";
import mixpanel from "mixpanel-browser";
import useWindowSize, { WindowSize } from "app/utils/useWindowSize";
import extractTedVideoSlug from "app/utils/extractTedVideoSlug";

export default function Game() {
  const gameData = useGameData();
  const gameState = useGameState();
  const gameDispatch = useGameActionDispatch();
  const currentRound = gameData?.levels?.[gameState.roundIndex];
  const { windowHeight } = useWindowSize();

  if (!currentRound) {
    return <></>;
  }

  function handleRoundComplete() {
    if (gameState.roundIndex >= (gameData?.levels.length ?? Infinity) - 1) {
      gameDispatch({ type: GameAction.GAME_COMPLETED });
    } else {
      console.log("completed level type: " + currentRound?.levelType);
      mixpanel.track("level_completed", {
        game_id: gameData?.id,
        levelType: currentRound?.levelType,
      });
      gameDispatch({ type: GameAction.ROUND_COMPLETED });
    }
  }

  return (
    <div className={cn("relative", "w-full h-full", "flex justify-center")}>
      <div
        className={cn(
          "h-full w-full max-w-125",
          windowHeight === WindowSize.SMALL ? "py-2" : "py-4",
          "px-2.5",
          "flex flex-col gap-2",
          "overflow-x-hidden lg:overflow-x-visible",
        )}
      >
        <div // HEADER CONTAINER
          className={cn(
            "w-full",
            "flex flex-col items-center gap-1",
            "mb-0 lg:mb-3",
          )}
        >
          <Header className="w-full">
            {ROUND_TITLE_BY_ROUND_TYPE[currentRound.levelType]}
          </Header>
          {/* // Experimenting with moving this to the round start screen
           <p className="text-sm text-gray-800">
            Round {(gameState.roundIndex + 1).toString()} -{" "}
            {currentRound.difficulty ?? "Easy"}
          </p> */}
        </div>
        <div // ROUND CONTAINER
          className={cn("flex-1")}
        >
          {currentRound.levelType === RoundType.SPELLING_BEE && (
            <SpellingBeeRound
              roundIndex={gameState.roundIndex}
              words={currentRound.words ?? []}
              onComplete={handleRoundComplete}
            />
          )}
          {currentRound.levelType === RoundType.BUZZ_IN && (
            <BuzzInRound
              roundIndex={gameState.roundIndex}
              words={currentRound.words ?? []}
              onComplete={handleRoundComplete}
            />
          )}
          {currentRound.levelType === RoundType.SPEED && (
            <SpeedRound
              roundIndex={gameState.roundIndex}
              category={currentRound.category ?? ""}
              words={currentRound.words ?? []}
              onComplete={handleRoundComplete}
            />
          )}
          {currentRound.levelType === RoundType.TED_WORD && (
            <TedWordRound
              roundIndex={gameState.roundIndex}
              sentence={currentRound.words[0]?.transcript ?? ""}
              videoSlug={extractTedVideoSlug(currentRound.videoUrl ?? "")}
              videoStartTime={currentRound.videoStartTime ?? 0}
              videoEndTime={currentRound.videoEndTime ?? 0}
              videoWordTime={currentRound.videoWordTime ?? 0}
              word={currentRound.words[0] ?? []}
              onComplete={handleRoundComplete}
            />
          )}
          {currentRound.levelType === RoundType.ONE_CHANCE && (
            <OneChanceRound
              roundIndex={gameState.roundIndex}
              word={currentRound.words[0] ?? []}
              onComplete={handleRoundComplete}
            />
          )}
        </div>
      </div>
    </div>
  );
}
